var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77764 1.13519C1.59974 0.954938 1.31132 0.954938 1.13343 1.13519C0.955524 1.31543 0.955524 1.60765 1.13343 1.78789L1.77764 1.13519ZM6.27767 6.34729L5.95552 6.6736L6.27767 6.34729ZM6.27767 7.65271L5.95552 7.3264L6.27767 7.65271ZM1.13343 12.2121C0.955524 12.3923 0.955524 12.6846 1.13343 12.8649C1.31132 13.045 1.59974 13.045 1.77764 12.8649L1.13343 12.2121ZM1.13343 1.78789L5.95552 6.6736L6.59973 6.02089L1.77764 1.13519L1.13343 1.78789ZM5.95552 7.3264L1.13343 12.2121L1.77764 12.8649L6.59973 7.97911L5.95552 7.3264ZM5.95552 6.6736C6.13345 6.85388 6.13345 7.14612 5.95552 7.3264L6.59973 7.97911C7.13342 7.43837 7.13342 6.56163 6.59973 6.02089L5.95552 6.6736Z",
    fill: "#999999",
    stroke: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreater);
export default __webpack_public_path__ + "static/media/greater.3030198e11b0749da39b71e11c524602.svg";
export { ForwardRef as ReactComponent };